<template>
  <div>
    <div v-if="loaded" class="products_wrapper">
      <div class="row mb-4 p-row py-2" v-for="item in items" :key="item.id">
        <div class="col-2">
          <div @click="$modal.show('croppa_modal', { product: item, image: null })">
            <i class="material-icons">add_a_photo</i>
          </div>
        </div>
        <div class="col-10">
          <h6>{{ item.name }}</h6>
          <small>{{ item.id }} {{ item.reference }}</small>
          <ul class="list-inline mt-3" v-if="item.images">
            <li
              class="list-inline-item text-center"
              v-for="(image, index) in item.images"
              :key="index"
              :id="'li_' + image.id"
            >
              <div
                @click="$modal.show('croppa_modal', { product: item, image: image })"
                class="pointer"
              >
                <img
                  :src="getImgUrl(image.image_path)"
                  class="product_thumb"
                  v-if="image.image_path"
                />
              </div>
              <svg-icon
                icon-class="check-circle"
                :style="{ color: image.cover ? '#55D14C' : '#D8D8D8' }"
                @click="update_cover(item, image)"
              ></svg-icon>
              <svg-icon
                icon-class="close-circle"
                style="color: #ff6b6b"
                @click="show_delete_modal(image, index)"
                class="ml-4"
              ></svg-icon>
            </li>
          </ul>
        </div>
      </div>
      <div class="mt-5">
        <paginator :dataSet="dataSet" @page_changed="fetch"></paginator>
      </div>
    </div>
    <div v-else>
      <h5 class="my-5">{{ site_name }}</h5>
    </div>

    <div class="container pb-3 footer">
      <div class="input-group">
        <input
          type="text"
          v-model="search_input"
          placeholder="recherche"
          @change="fetch(1)"
          class="flex-grow-1 search_input"
        />
        <svg-icon
          icon-class="barcode-frame"
          id="barcode-frame-icon"
          @click="require_scan()"
        ></svg-icon>
      </div>
    </div>

    <modal name="scan_modal" :width="windowWidth > 900 ? '800' : '100%'" height="auto">
      <div class="card">
        <div class="card-header">
          <h4>{{ $t("admin.image") }}</h4>
          <button class="btn btn-secondary btn-sm ml-auto" @click="close_scan()">
            &times;
          </button>
        </div>
        <div class="card-body">
          <quagga-scanner
            :onDetected="onDetected"
            :readerSize="readerSize"
            :readerTypes="['code_128_reader']"
            v-if="scanning"
          ></quagga-scanner>
        </div>
      </div>
    </modal>

    <modal
      name="croppa_modal"
      :width="windowWidth >= 1300 ? '1260px' : '100%'"
      height="auto"
      :scrollable="true"
      @before-open="
        (event) => {
          params = event.params;
        }
      "
    >
      <div class="card">
        <div class="card-header">
          <h4>{{ $t("admin.image") }}</h4>
          <button
            class="btn btn-secondary btn-sm ml-auto"
            @click="$modal.hide('croppa_modal')"
          >
            &times;
          </button>
        </div>
        <div class="card-body text-center px-0">
          <croppa
            v-model="croppa"
            placeholder="Cliquez ou glissez le fichier ici."
            :placeholder-font-size="12"
            auto-sizing
            :width="width"
            :height="height"
            :quality="quality"
            accept=".jpg, .jpeg, .png"
            :prevent-white-space="false"
          ></croppa>
          <div class="btns">
            <button
              class="btn btn-outline-success rounded-0"
              @click="uploadCroppedImage()"
            >
              {{ $t("admin.save") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="delete_modal"
      :width="windowWidth > 900 ? '800' : '100%'"
      height="auto"
      :scrollable="true"
    >
      <div class="p-4">
        <p>{{ $t("admin.delete_confirm") }}</p>
        <div class="text-right">
          <button class="btn btn-outline-primary rounded-0" @click="delete_image">
            {{ $t("admin.validate") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: "/products",
      loaded: false,
      dataSet: false,
      items: [],
      search_input: "",
      order_column: null,
      order: null,
      params: null,
      //
      croppa: {},
      image_width: parseInt(localStorage.getItem("image_width")),
      image_height: parseInt(localStorage.getItem("image_height")),
      scanning: false,
      site_name: localStorage.getItem("site_name"),
      result: null,
      // vue-quagga
      readerSize: {
        width: 350,
        height: 350,
      },
      aspectRatio: { min: 1, max: 1 },
      detecteds: [],
    };
  },
  created() {
    this.fetch();
  },
  computed: {
    // width for croppa
    width() {
      // if(window.innerWidth>1210) return 1200;
      if (window.innerWidth > 610) return 600;
      if (window.innerWidth > 410) return 400;
      return 300;
    },
    // height for croppa
    height() {
      return parseInt((this.width * this.image_height) / this.image_width);
    },
    // quality for croppa
    quality() {
      // let quality = this.windowWidth < this.image_width ? parseInt(this.image_width/this.windowWidth)+1 : 1;
      let quality =
        this.image_width > this.width ? parseInt(this.image_width / this.width) : 1;
      console.log("quality", quality);
      return quality;
    },
  },
  methods: {
    fetch(page) {
      this.loaded = false;
      axios.defaults.baseURL =
        localStorage.getItem("site_url") + localStorage.getItem("api");
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("user-token");
      axios
        .get(this.url(page))
        .then(({ data }) => {
          console.log("loaded data", data);
          this.dataSet = data;
          this.items = data.data;
          this.loaded = true;
          console.log("items", this.items);
        })
        .catch((error) => {
          console.log(error.response.data);
          this.flash(error.response.data.message);
          this.$store.dispatch("logoutAction");
        });
    },
    url(page) {
      if (!page) page = 1;
      var url = this.path + "?page=" + page;
      if (this.search_input.length > 0) url += `&search=${this.search_input}`;
      if (this.order_column)
        url += `&order_column=${this.order_column}&order=${this.order}`;
      if (this.id > 0) url += `&id=${this.id}`;
      return url;
    },

    show_delete_modal(item, index) {
      this.$modal.show("delete_modal");
      this.id_delete = item.id;
      this.index_delete = index;
    },

    uploadCroppedImage() {
      this.croppa.generateBlob(
        (blob) => {
          console.log("params", this.params);
          // write code to upload the cropped image file (a file is a blob)
          let fmData = new FormData();
          const extension = blob.type.split("/")[1];
          fmData.append("image", blob, "filename." + extension);
          fmData.append("product_id", this.params.product.id);
          // hold the old image in case update date image
          if (this.params.image) {
            fmData.append("image_id", this.params.image.id);
            const image_path_holder = this.params.image.image_path;
            this.params.image.image_path = ""; // to re-render de image
          }
          this.logFormData(fmData);
          const uploadUrl = "/images";
          axios
            .post(uploadUrl, fmData)
            .then(({ data }) => {
              console.log("data", data);
              // update image
              if (this.params.image) {
                this.params.image.image_path = data.image.image_path;
              }
              // add image
              else {
                this.params.product.images.push(data.image);
              }
              this.$modal.hide("croppa_modal");
            })
            .catch((error) => {
              console.log(error, "danger");
              // update image
              if (this.params.image) {
                this.params.image.image_path = image_path_holder; // image_path_holder is undefined
              }
            });
        },
        "image/jpeg",
        0.8
      ); // 80% compressed jpeg file
    },
    delete_image() {
      axios
        .delete("/images", { data: { image_id: this.id_delete } })
        .then(({ data }) => {
          console.log("delete image response", data);
          if (data.status == "success") {
            $("#li_" + this.id_delete).hide();
            flash(data.message);
            this.id_delete = undefined;
            this.$modal.hide("delete_modal");
          } else {
            flash(data.message, "danger");
          }
        })
        .catch((error) => {
          console.log(error, "danger");
        });
    },
    update_cover(product, image) {
      console.log("product", product);
      console.log("image", image);
      product.images.forEach((elem) => (elem.cover = false));
      image.cover = true;
      return;
      axios
        .patch("/images", { image_id: image.id })
        .then(({ data }) => {
          console.log("image cover update response", data);
          product.images.forEach((elem) => (elem.cover = false));
          image.cover = true;
        })
        .catch((error) => {
          console.log(error, "danger");
        });
    },
    require_scan() {
      this.$modal.show("scan_modal");
      this.scanning = true;
    },
    close_scan() {
      this.$modal.hide("scan_modal");
      this.scanning = false;
    },
    onDetected(data) {
      console.log("detected", data);
      this.close_scan();
      this.search_input = data.codeResult.code;
      this.fetch();
    },
  },
};
</script>
